<template>
  <section>
    <div class="page-content pt-4">
      <button
        v-if="tanentType != 'ted' && surveyType == 'YES'"
        type="button"
        class="btn export-btn export-btn-yes btn-outline-light px-4 mx-3"
        @click="exportContactsDetails()"
      >
        export contacts details
        <span class="ms-2">
          <img
            src="@/assets/images/comments-page/download.svg"
            alt="download"
          />
        </span>
      </button>
      <comments-sidebar @filter-comments="filterComments"></comments-sidebar>
      <div class="comments-container" v-if="currentComments">
        <all-comments-container
          :comments="currentComments"
        ></all-comments-container>
      </div>
      <template v-else>
        <the-loading />
      </template>
    </div>
  </section>
</template>

<script>
import AllCommentsContainer from "@/components/dashboard/surveys-charts/individual/survey-comments/all-comments-container.vue";
import CommentsSidebar from "@/components/dashboard/surveys-charts/individual/survey-comments/comments-sidebar.vue";
import { mapGetters } from "vuex";

export default {
  name: "SurveyComments",
  components: {
    AllCommentsContainer,
    CommentsSidebar,
  },
  data() {
    return {
      groupName: "",
    };
  },
  computed: {
    ...mapGetters("mainStats", {
      contactsDetails: "getContactsDetails",
      allCommentsIsPositive: "allCommentsIsPositive",
      positiveCommentStarred: "getPositiveCommentStarred",
      negativeCommentStarred: "getNegativeCommentStarred",
      allCommentsPositiveData: "getAllCommentsPositiveData",
      allCommentsNegativeData: "getAllCommentsNegativeData",
      allCommentsData: "getAllCommentsData",
    }),
    currentComments() {
      let comments;
      if (this.groupName == "starred") {
        comments =
          this.allCommentsIsPositive == true
            ? this.filterCommentsByGroup("positiveCommentStarred")
            : this.filterCommentsByGroup("negativeCommentStarred");
      } else if (this.groupName == "archived") {
        comments =
          this.allCommentsIsPositive == true
            ? this.filterCommentsByGroup("positiveCommentArchived")
            : this.filterCommentsByGroup("negativeCommentArchived");
      } else {
        comments =
          this.allCommentsIsPositive == true
            ? this.allCommentsPositiveData?.filter(
                (comment) => comment.positiveCommentArchived == false
              )
            : this.allCommentsNegativeData?.filter(
                (comment) => comment.negativeCommentArchived == false
              );

        // return this.allCommentsData.filter((item) => item[group] == true);

        // ask sara
        // comments = allComments?.filter(
        //   (item) =>
        //     item.positiveCommentArchived == false &&
        //     item.negativeCommentArchived == false
        // );
      }
      return comments;
    },

    surveyType() {
      return this.$route.params.type;
    },

    tanentType() {
      return this.$store.getters["auth/tenantType"].toLowerCase();
    },
  },

  methods: {
    filterComments(type) {
      this.groupName = type;
    },
    exportContactsDetails() {
      this.$store.dispatch(
        "mainStats/exportContactsDetails",
        this.$route.params.id
      );
    },
    filterCommentsByGroup(group) {
      return this.allCommentsData.filter((item) => item[group] == true);
    },
  },
  async mounted() {
    try {
      await this.$store.dispatch("mainStats/fetchCommentsNotes", {
        surveyId: this.$route.params.id,
      });
      if (!this.allCommentsData) {
        await this.$store.dispatch("mainStats/fetchSurveyComments", {
          surveyId: this.$route.params.id,
        });
      }
    } catch (error) {
      this.$store.dispatch("dialog/showErrorDialog", {
        error: error,
      });
    }
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
.survey-name-container {
  border-bottom: $border-grey-60;
}

.export-btn.btn {
  border-radius: $radius-20;
  span {
    line-height: 1.5rem;
    font-size: $font-size-16;
    font-weight: $font-weight-regular;
  }

  &:focus {
    box-shadow: unset;
  }

  &:hover {
    img {
      filter: invert(1);
    }
  }
}

.export-btn-yes {
  position: fixed;
  //right: 3.5rem;
  // top: 2rem;
  right: 13rem;
  top: 2.6rem;
}
</style>
